import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('global-notification',{
	state: () => ({
    modalMessage: '', // may be a object (depending server's response)
    hasError: false
	}),
	getters: {
    getMessage: (state) => {
      return state.modalMessage
    },
    hasErrorFromServer: (state) => state.hasError
	},
	actions: {
		setMessage (message = '') {
      this.modalMessage = message;
    },
    setErrorModal (data = {}) {
      this.modalMessage = data.modalMessage;
      this.hasError = true
    },
    setSuccessModal (data = {}) {
      this.modalMessage = data.modalMessage;
      this.hasError = false
    },
	},
});
